import { generateHTML } from '@tiptap/core'

import { jsonConvert } from '../../../helpers/jsonConvert'
import { BlockMath } from 'react-katex';
import { getTiptapExtensions } from '@UI/Tiptap/tiptap-extensions'
import { onvertingRelativeURLsToAbsoluteOnes } from './helpers/onvertingRelativeURLsToAbsoluteOnes';

const JsonPars = ({ json }) => {
  const data = jsonConvert(json, 'json')
  if (typeof data === 'string') return data
  if (typeof data === 'number') return data
  else if (data?.type === undefined) return ''
  return <Html data={data} />
}

const Html = ({ data }) => {
  const formatString = (text) => {
    let newText = text.replace(/ /g, '\\,').replace(/\n/g, '\\\\'); // заменяем пробелы и переносы на те, которые будут здесь работать
  
    const mathSymbolsRegex = /([−+=*:<>∩∪≤≥∈∥-])/g; // Обрабатываем +, =, *, -, <, >, ∩, ∪,
    newText = newText.replace(mathSymbolsRegex, '\\text{$1}');

    // Обрабатываем \cap и \cup
    newText = newText.replace(/\\cap/g, '~\\cap~');
    newText = newText.replace(/\\cup/g, '~\\cup~');
    newText = newText.replace(/\\leqslant/g, '~\\leqslant~');
    newText = newText.replace(/\\geqslant/g, '~\\geqslant~');
    newText = newText.replace(/\\parallel/g, '~\\parallel~');
    newText = newText.replace(/\\notin/g, '~\\notin~');
    newText = newText.replace(/\\in(?!\w)/g, '~\\in~');
    newText = newText.replace(/\\ge(?!\w)/g, '~\\ge~');
    newText = newText.replace(/\\le(?!\w)/g, '~\\le~');
    newText = newText.replace(/\\neq(?!\w)/g, '~\\neq~');
    newText = newText.replace(/\\equiv(?!\w)/g, '~\\equiv~');
    
    newText = newText.replace(/\\cdot/g, '~\\cdot~');
    newText = newText.replace(/%/g, '\\%');

    return newText;
  };
  const content = onvertingRelativeURLsToAbsoluteOnes(data?.content) ?? [];

  return <>
    {content?.map((item, i) => {
      if (item?.type === 'math') {
        const formattedText = formatString(item?.attrs?.value);
        return <BlockMath key={i}>{formattedText}</BlockMath>
      }
      return (
        <span 
          className='tiptapStyle' 
          key={i} 
          dangerouslySetInnerHTML={{ 
            __html: generateHTML(
              { type: 'doc', content: [item] }, 
              getTiptapExtensions()
          ) }} />
      )
    })}
  </>
}

export default JsonPars;
